export default __webpack_public_path__ + "static/media/Love09.7a658035.png";